export enum SettingType {
    COLOR,
    STROKE_WIDTH,
    LINE_TYPE,
    LINE_HEAD_TYPE,
    COORDINATE,
    SELECT,
    TEXT,
    TEXT_AREA,
    FONT,
    NUMBER,
    BOOLEAN,
}